import React, { FC } from 'react';

import { Row } from 'antd';
import { useIntl } from 'react-intl';
import ChallengeResourceWrapper from 'src/components/challenge/ChallengeResourceWrapper';
import { ChallengeTypeEnum } from 'src/shared/enums';
import { IChallengeResourceRender, ILinkedChallenges } from 'src/shared/models';
import { renderChallengeCard } from 'utils';

interface OwnProps extends IChallengeResourceRender {
  config: ILinkedChallenges;
}

const ChallengeLinkedChallenges: FC<OwnProps> = ({ config }): JSX.Element => {
  const { locale, formatMessage } = useIntl();

  if (!config || !config?.challenges?.length) return <React.Fragment />;

  const {
    challenges,
    description,
    points,
    title,
    isCampaignActivator,
    isCompleted,
    type,
  } = config;

  const getClassNameByType = (type: ChallengeTypeEnum) => {
    switch (type) {
      case ChallengeTypeEnum.CAMPAIGN:
        return 'campaignsPage';
      case ChallengeTypeEnum.FORMATION:
        return 'trainingPage';
      case ChallengeTypeEnum.TALK:
        return 'talksPage';
    }
  };

  const getIconByType = (type: ChallengeTypeEnum): string => {
    switch (type) {
      case ChallengeTypeEnum.ANNUAL_CAMPAIGN:
        return 'medal';
      case ChallengeTypeEnum.CAMPAIGN:
        return 'campaign-map';
      case ChallengeTypeEnum.FORMATION:
        return 'challenge';
      case ChallengeTypeEnum.TALK:
        return 'map-pin';
      default:
        return 'medal';
    }
  };

  const component = (
    <Row justify="start" gutter={[24, 24]} className={getClassNameByType(type)}>
      {challenges.map((challenge) =>
        renderChallengeCard({ challenge, isLinkedChallenge: true })
      )}
    </Row>
  );

  return (
    <ChallengeResourceWrapper
      styleClass="challengeDetail--LinkedChallenge"
      description={description}
      icon={getIconByType(type)}
      points={
        points > 0 &&
        formatMessage(
          { id: 'page.challenge.plus-sign-{points}-points' },
          { points: Number(points).toLocaleString(locale) }
        )
      }
      title={title}
    >
      {component}
    </ChallengeResourceWrapper>
  );
};

export default ChallengeLinkedChallenges;
